

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Reservation.css';

const Reservation = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const [selectedService, setSelectedService] = useState('');
  const [selectedDateTime, setSelectedDateTime] = useState('');
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [submitMessage, setSubmitMessage] = useState('');

  useEffect(() => {
    fetch('https://api.kasbah-magic.com/conciergeLastVersion/index.php?action=getTitle_service')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        if (data.success) {
          setServices(data.services);
        } else {
          throw new Error(data.message || 'Failed to fetch services');
        }
      })
      .catch(err => {
        console.error('Error fetching services:', err);
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    const parsedPhoneNumber = parseInt(value, 10);
    if (!isNaN(parsedPhoneNumber)) {
      setPhoneNumber(parsedPhoneNumber);
    } else {
      setPhoneNumber(null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitStatus('submitting');
    setSubmitMessage('');

    const reservationData = {
      service_type: selectedService,
      reservation_date: selectedDateTime,
      phone: phoneNumber,
      status: 'pending'
    };

    console.log('Sending reservation data:', reservationData);

    fetch('https://api.kasbah-magic.com/conciergeLastVersion/index.php?action=create_reservation', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reservationData)
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setSubmitStatus('success');
          setSubmitMessage(t('reservationSuccess', 'Reservation submitted successfully'));
          // Reset form
          setSelectedService('');
          setSelectedDateTime('');
          setPhoneNumber(null);
        }
        else {
          setSubmitStatus('error');
          setSubmitMessage(`${t('reservationFailed', 'Failed to submit reservation')}: ${data.message}`);
        }
        // Clear status and message after 5 seconds (5000ms)
        setTimeout(() => {
          setSubmitStatus(null);
          setSubmitMessage('');
        }, 5000);
      })
      .catch(err => {
        console.error('Error submitting reservation:', err);
        setSubmitStatus('error');
        setSubmitMessage(t('serverError', 'Server error occurred'));
        // Clear status and message after 5 seconds (5000ms)
        setTimeout(() => {
          setSubmitStatus(null);
          setSubmitMessage('');
        }, 5000);
      });
  };

  return (
    <div
      id="reservation-section"
      className={`reservation-container ${language === 'ar' ? 'rtl' : 'ltr'}`}
    >
      <div className="reservation-content">
        <div className="reservation-header">
          <h1 className="reservation-title">{t('reservationTitle')}</h1>
          <p className="reservation-subtitle">{t('reservationSubtitle')}</p>
        </div>

        {loading ? (
          <p>{t('loading', 'Loading...')}</p>
        ) : error ? (
          <p className="error-message">{error}</p>
        ) : (
          <form onSubmit={handleSubmit} className="reservation-form">
            <select
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
              className="form-select"
              required
            >
              <option value="">{t('selectService')}</option>
              {services.map((service, index) => (
                <option key={index} value={service.name}>
                  {service.name}
                </option>
              ))}
            </select>

            <input
              type="datetime-local"
              value={selectedDateTime}
              onChange={(e) => setSelectedDateTime(e.target.value)}
              className="form-date"
              required
            />

            <input
              type="number"
              value={phoneNumber || ''}
              onChange={handlePhoneChange}
              className="form-phone"
              placeholder={t('phonePlaceholder')}
              required
            />

            <button type="submit" className="form-button" disabled={submitStatus === 'submitting'}>
              {submitStatus === 'submitting' ? t('submitting', 'Submitting...') : t('submitRequest')}
            </button>
          </form>
        )}

        {submitStatus === 'success' && (
          <div className="success-message">
            {submitMessage}
          </div>
        )}

        {submitStatus === 'error' && (
          <div className="error-message">
            {submitMessage}
          </div>
        )}
      </div>
    </div>
  );
};

export default Reservation;
